import React from 'react'
import { View } from 'react-native'

import { BtText } from '@linqpal/components/src/ui'

export const ProjectTileCard = ({ title, value, icon, testID }) => {
  return (
    <View
      style={{
        marginTop: 32,
        borderWidth: 1,
        borderColor: '#E6EBEE',
        borderRadius: 8,
        paddingVertical: 18,
        paddingHorizontal: 24,
        marginRight: 20,
        flex: 1,
      }}
    >
      <View>
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
          }}
        >
          <BtText
            style={{
              color: '#668598',
              fontSize: 16,
              fontWeight: '500',
              marginRight: 8,
            }}
          >
            {title}
          </BtText>

          {icon}
        </View>
        <BtText
          testID={testID}
          style={{
            marginTop: 10,
            color: '#335C75',
            fontWeight: '600',
            fontSize: 18,
          }}
        >
          {value}
        </BtText>
      </View>
    </View>
  )
}
